/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-07 17:27:41
 */
const shopManageMenus = [
	{
		path: '/shopManage',
		component: null,
		name: '商品',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		redirect: '/commercial',
		children: [
			{
				path:'commercial',
				component: null,
				name: '商品公海',
				id: 3,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/commercial/list',
				children: [
					{
						path: 'list',
						component: 'shopManage/commercialHigh',
						parentId: 3,
						name: 'list',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'promoteList',
						component: 'shopManage/commercialHigh/components/myPromonteGoods',
						parentId: 4,
						name: '我的推广商品',
						showBread: true,
						useTemplate: false,
						visible: true,
						children: null,
					}
				]
			},
			{
				path: 'tobeClaime',
				component: null,
				name: '团长商品',
				id: 3,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/tobeClaime/list',
				children: [
					{
						path: 'list',
						component: 'shopManage/tobeClaimed/list',
						parentId: 3,
						name: 'list',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'detail',
						name: '商品详情',
						component: 'shopManage/tobeClaimed/detail',
						parentId: 3,
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'trusteeship',
				component: null,
				name: '托管商品',
				id: 4,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/trusteeship/list',
				children: [
					{
						path: 'list',
						component: 'shopManage/trusteeship/list',
						parentId: 4,
						name: 'list',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'detail',
						name: '商品详情',
						component: 'shopManage/trusteeship/detail',
						parentId: 4,
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'shopLibrary',
				name: '商品库',
				component: null,
				id: 5,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/shopLibrary/list',
				children: [
					{
						path: 'list',
						name: 'list',
						parentId: 5,
						component: 'shopManage/shopLibrary/list',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},

					{
						path: 'shopLibraryDetails',
						component: 'shopManage/shopLibrary/detail',
						name: '商品详情',
						parentId: 5,
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
					{
						path: 'waste',
						component: 'shopManage/shopLibrary/list/waste',
						name: '回收站',
						parentId: 5,
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
					{
						path: 'record',
						component: 'shopManage/orderDetails/record',
						name: '导出记录',
						parentId: 5,
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
					{
						path: 'addMaterial',
						component: 'shopManage/shopLibrary/addMaterial/addMaterial.vue',
						icon: 'system',
						id: 11,
						keepAlive: false,
						name: '关联素材',
						parentId: 5,
						showBread: true,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'shopGroup',
				name: '商品组',
				component: null,
				id: 6,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/shopGroup/group',
				children: [
					{
						path: 'group',
						component: 'shopManage/shopGroup/group',
						name: 'group',
						parentId: 6,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'detail',
						component: null,
						name: '商品组详情',
						// meta: { isMenu: false, title: '商品组详情' },
						id: 66,
						parentId: 6,
						keepAlive: false,
						showBread: true,
						visible: true,
						useTemplate: false,
						redirect: '/shopGroup/detail/list',
						children: [
							{
								path: 'list',
								name: '',
								component: 'shopManage/shopGroup/detail/list',
								parentId: 66,
								showBread: true,
								useTemplate: true,
								visible: true,
								children: null,
							},
							{
								path: 'shopDetails',
								component: 'shopManage/shopGroup/detail/shopDetails',
								name: '商品详情',
								parentId: 66,
								showBread: true,
								useTemplate: true,
								visible: true,
								children: null,
							},
						],
					},
				],
			},
			{
				path: 'extenTecord',
				component: null,
				name: '推广记录',
				id: 77,
				parentId: 6,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/extenTecord/list',
				children: [
					{
						path: 'list',
						name: 'list',
						component: 'extenTecord/list',
						parentId: 77,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'details',
						component: null,
						// meta: { isMenu: false, title: '推广商品列表' },
						name: '推广商品列表',
						id: 78,
						parentId: 77,
						keepAlive: false,
						showBread: false,
						visible: true,
						useTemplate: false,
						redirect: '/extenTecord/details/list',
						children: [
							{
								path: 'list',
								name: 'list',
								component: 'extenTecord/details/list',
								parentId: 78,
								showBread: true,
								useTemplate: true,
								visible: true,
								children: null,
							},
							{
								path: 'shopDetails',
								name: '商品信息',
								component: 'extenTecord/details/shopDetails',
								parentId: 78,
								showBread: true,
								useTemplate: true,
								visible: true,
								children: null,
							},
						],
					},
				],
			},
			{
				path: 'pallet',
				component: null,
				name: '货盘',
				id: 7,
				parentId: 2,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: true,
				redirect: '/shopManage/pallet/list',
				children: [
					{
						path: 'list',
						name: 'list',
						component: 'shopManage/pallet',
						parentId: 7,
						id: 99,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'tagManagement',
				component: null,
				name: '标签管理',
				id: 8,
				parentId: 2,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/tagManagement/list',
				children: [
					{
						path: 'list',
						name: 'list',
						component: 'shopManage/tagManagement/list',
						parentId: 8,
						id: 899,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
			// {
			// 	path: '/shopLibrary/record',
			// 	component: orderDetailsRecord,
			// 	meta: { isMenu: false, title: '导出记录' },
			// },
			{
				path: 'selectionDecoration',
				component: null,
				name: '选品中心装修',
				id: 9,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/shopManage/selectionDecoration/list',
				children: [
					{
						path: 'list',
						name: 'list',
						component: 'shopManage/selectionDecoration/list',
						parentId: 9,
						id: 900,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
		],
	},
];
export default shopManageMenus;
